import { createContext, useContext } from "react";
import type { StaffUser } from "@/lib/staff-api";

export interface StaffAuthContextValue {
  staff: StaffUser | null;
  isAuthenticated: boolean;
  /** Resolves with the signed-in staff member, so the caller can route by role. */
  login: (email: string, password: string) => Promise<StaffUser>;
  logout: () => void;
  /** True from first render while a stored session is being restored. */
  restoring: boolean;
}

// The context and hook live apart from the provider component, so the
// provider's file exports only a component (react-refresh/only-export-components).
export const StaffAuthContext = createContext<StaffAuthContextValue | null>(null);

export function useStaffAuth(): StaffAuthContextValue {
  const context = useContext(StaffAuthContext);
  if (!context) {
    throw new Error("useStaffAuth must be used within a StaffAuthProvider");
  }
  return context;
}
